import { Box, Heading, Icon, Paragraph, Text, Upsell } from '@zillow/constellation-10';
import { IconHouseHeartFilled } from '@zillow/constellation-icons';

import {
  wizardFlexContainerStyles,
  wizardFormSectionContainerStyles,
  wizardHeadingStyles,
} from '../../../../styles/wizard';

import FinancialExpectationsFormField from '../../../PostingPath/FinancialExpectationsFormField';
import PetsAllowedFormField from '../../../PostingPath/PetsAllowedFormField';
import PageWizard from '../../../Wizard/PageWizard';

import type { WizardBodyTemplateProps } from '../../../WizardStepController';

const ScreeningCriteriaAndPolicies = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  showDesktopViewBreakpoint,
  ...rest
}: WizardBodyTemplateProps) => {
  return (
    <PageWizard
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onGoToNextStep || undefined}
      onBackClick={onGoToPrevStep || undefined}
      onExitTriggered={onExitWizard}
      showDesktopViewBreakpoint={showDesktopViewBreakpoint}
      {...rest}
    >
      <div data-testid="ScreeningCriteriaAndPolicies">
        <Heading textStyle="heading-md" level={2} css={wizardHeadingStyles}>
          Screening criteria and policies
        </Heading>
        <Paragraph css={{ marginBottom: '600' }}>
          These criteria appear on your listing so renters can see if they qualify, and help you quickly see who’s a
          good fit.
        </Paragraph>
        <Box css={wizardFlexContainerStyles}>
          <Box data-testid="FormSectionContainer" css={wizardFormSectionContainerStyles.raw()}>
            <Heading textStyle="heading-xs" level={3} css={wizardHeadingStyles}>
              What are your financial criteria?
            </Heading>
            <FinancialExpectationsFormField />
            <Upsell
              css={{ marginTop: '800', marginBottom: '800' }}
              elevated={false}
              action={null}
              tone="soft"
              header={
                <Heading textStyle="heading-sm" level={3}>
                  Increase the chance of finding a tenant on Zillow
                </Heading>
              }
              body={
                <Paragraph>
                  More landlords who set screening criteria reported finding their renter on Zillow.
                </Paragraph>
              }
              legal={<Text>Source: Zillow internal data, Q1 2024</Text>}
              media={<Icon render={<IconHouseHeartFilled />} />}
              closeable={false}
            />

            <Heading textStyle="heading-xs" level={3} css={wizardHeadingStyles}>
              What&apos;s your pet policy?
            </Heading>

            <PetsAllowedFormField showUpsell={true} />
          </Box>
        </Box>
      </div>
    </PageWizard>
  );
};

export default ScreeningCriteriaAndPolicies;
